import { InformationVideosService } from '@appStore/learning/services/information-videos.service';

export const services: any[] = [ InformationVideosService ];

export * from '@appStore/learning/services/information-videos.service';

